import { TabQueryState } from '@/components/layout/query-state';
import { PageTitle } from '@/components/seo/page-title';
import { NotificationsScreen } from '@/features/notifications/notifications-screen';
import React from 'react';
import { useNotificationActions } from './hooks/use-notification-actions';

export function NotificationsRouteScreen() {
  const actions = useNotificationActions();

  return (
    <TabQueryState
      isLoading={actions.isLoading}
      error={actions.error}
      onRetry={() => actions.refetch()}
      loadingMessage="Loading notifications..."
    >
      <PageTitle title="Notifications" />
      <NotificationsScreen
        notifications={actions.notifications}
        actionableFriendRequestNotificationIds={actions.actionableFriendRequestNotificationIds}
        onMarkAsRead={actions.handleMarkAsRead}
        onMarkAllAsRead={actions.handleMarkAllAsRead}
        onNotificationPress={actions.handleNotificationPress}
        onAcceptFriendRequest={actions.handleAcceptFriendRequest}
        onRejectFriendRequest={actions.handleRejectFriendRequest}
        processingFriendRequestIds={actions.processingFriendRequestIds}
      />
    </TabQueryState>
  );
}
